import { servicios } from '../properties';
var axios = require('axios');
import appTimer from '../app-timer';

export const validarPass = (sParam) => {
    return fetch(servicios.validarPass, {
        method: 'post',
        body: JSON.stringify({
            contrasena: sParam,
        })
    })
}
export const guardarContrasena = (sParam) => {
    return fetch(servicios.guardarContrasena, {
        method: 'post',
        body: JSON.stringify({
            contrasena: sParam.contrasena,
            confirmacion: sParam.confirmacion
        })
    });
}
export const guardarPreguntas = (sParam) => {
    return fetch(servicios.guardarPreguntas, {
        method: 'post',
        body: JSON.stringify({
            p1: sParam.p1,
            r1: sParam.r1,
            p2: sParam.p2,
            r2: sParam.r2,
            pass: sParam.pass
        })
    });
}
export const verificarPregunta = (sParam) => {
    return fetch(servicios.verificarPregunta, {
        method: 'post',
        body: JSON.stringify({
            p: sParam.p,
            r: sParam.r
        })
    });
}
export const verificarCodigo = (sParam) => {
    return fetch(servicios.verificarCodigo, {
        method: 'post',
        body: JSON.stringify({
            codigo: sParam.codigo
        })
    });
}

export const validacionEmail = (email) => {
    return axios.get(servicios.utilerias.validadorMediosContacto + `/validador/formato-email?email=${email}`, {
        headers: {
            apikey: servicios.utilerias.apiKeyMC
        }
    })
}

export const validacionTel = (numTelefono) => {
    return axios.get(servicios.utilerias.validadorMediosContacto + `/validador/formato-telefono?telefono=${numTelefono}`, {
        headers: {
            apikey: servicios.utilerias.apiKeyMC
        }
    })
}


// WEBPACK FOOTER //
// ./src/miPerfil/servicios.act.js